var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-submenu-title"},[_c('AppIcon',{staticClass:"app-submenu-title__icon",attrs:{"icon":_vm.icon,"size":_vm.iconSize}}),_c('h4',{staticClass:"app-submenu-title__text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }